import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BaseSiteService } from '@spartacus/core';
import { Subscription } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AuthInterceptorService } from 'src/app/auth-interceptor-service';
import { ChatbotService } from '../chatbot.service';

@Component({
    selector: 'app-chatbot',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './chatbot.component.html',
    standalone: false
})
export class ChatbotComponent implements OnInit, OnDestroy {
  chatbotEnabled = false;
  vaxAgentName = 'Viki';
  vshAgentName = 'Ava';
  agentName: string;
  baseSiteId: string;
  chatbotScriptElement: HTMLScriptElement;
  baseSiteSub: Subscription;
  routerSub: Subscription;

  constructor(
    private readonly baseSite: BaseSiteService,
    private readonly chatbotService: ChatbotService,
    private readonly authInterceptorService: AuthInterceptorService,
    private readonly router: Router,
    private readonly ref: ChangeDetectorRef,
    private readonly el: ElementRef,
    private readonly renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.baseSiteSub = this.baseSite
      .getActive()
      .pipe(take(1))
      .subscribe((res) => (this.baseSiteId = res));
    this.agentName =
      this.baseSiteId === 'vax' ? this.vaxAgentName : this.vshAgentName;

    this.routerSub = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        this.updateChatbotInfo();
      });

    this.updateChatbotInfo();
  }
  ngOnDestroy(): void {
    this.baseSiteSub?.unsubscribe();
    this.routerSub?.unsubscribe();
  }
  updateChatbotInfo(): void {
    const loadScript = () => {
      this.chatbotScriptElement = document.createElement('script');
      if (this.baseSiteId === 'vax') {
        this.chatbotScriptElement.src =
          'chatbot/vax-chatbot/chatbot_script.js';
      } else {
        this.chatbotScriptElement.src =
          'chatbot/vsh-chatbot/chatbot_script.js';
      }
      document.body.appendChild(this.chatbotScriptElement);
    };
    if (
      (window as any).isAnonymous === undefined ||
      (this.authInterceptorService.getUserId() === 'anonymous' &&
        (window as any).isAnonymous === false) ||
      (this.authInterceptorService.getUserId() !== 'anonymous' &&
        (window as any).isAnonymous === true)
    ) {
      this.chatbotService.getChatbotInfo(this.baseSiteId).subscribe((res) => {
        this.removeChatbot();
        if (this.authInterceptorService.getUserId() === 'anonymous') {
          (window as any).isAnonymous = true;
        } else {
          (window as any).isAnonymous = false;
        }
        (window as any).integrationId = res?.integrationId;
        (window as any).serviceInstanceId = res?.serviceInstanceId;
        this.chatbotEnabled = res?.enabled;
        if (this.chatbotEnabled) {
          loadScript();
        }
        this.ref.detectChanges();
      });
    }
  }

  removeChatbot(): void {
    const element = document.querySelector('.WatsonAssistantChatHost');
    if (element) {
      element.remove();
    }
  }
}
